import { AxiosRequestHeaders } from "axios";
import * as R from "ramda";

type Params = {
  view?: any;
  filter?: any;
  token?: any;
  button?: any;
  limit?: any;
  offset?: any;
};

const formatHeaders = ({
  view,
  filter,
  token,
  button,
  limit,
  offset,
}: Params): AxiosRequestHeaders =>
  R.pickBy(R.complement(R.isNil), {
    view,
    token,
    button,
    limit,
    offset,
    filter,
    filterstate: "remake",
  });

export default formatHeaders;
